﻿import { defineComponent, inject } from "/Scripts/vue.esm-browser.js";

const html = String.raw;

export default defineComponent({
    name: "StoresB2B",
    inject: ["companyInfo"],
    props: {
        webSite: {
            type: String,
            required: true,
        },
    },
    components: {},
    setup() {
        const openMaps = (OpenAdds, OpenName) => {
            const openURL = 'https://www.google.com.tw/maps/place/' + OpenAdds + '/?hl=zh-TW';
            window.open(openURL, '_blank');
        }
        return { openMaps };
    },
    template: html`
        <div class="stores">
            <div class="ctbox" :title="info.company" v-for="info in companyInfo">
                <strong>{{info.company}}</strong>
                {{info.address}}
                <a
                    @click="openMaps(info.address,'')"
                    class="sbtn"
                >
                    MAP
                </a>
                <br />
                {{info.phoneNumber}}
            </div>
            
        </div>
    `,
});
